<template>
    <el-row>
        <el-form-item>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">系统设置</el-breadcrumb-item>
                <el-breadcrumb-item>预警配置</el-breadcrumb-item>
            </el-breadcrumb>
        </el-form-item>
    </el-row>
    <el-row>
        <el-col :span="7">
            <el-button type="primary" icon="el-icon-circle-plus" @click="newClass">添加</el-button>
            <el-button :disabled="warningData.length<=1" type="primary" icon="el-icon-remove" @click="removeClass">删除</el-button>
            <el-tree
                    :data="warningData"
                    :props="defaultProps"
                    @node-click="classClick"
                    class="page-tree"
                    node-key="index"
                    :highlight-current="true"
            >
                <template #default="{ node ,data }">
                    <span class="custom-tree-node">
                        <span>{{node.label}}</span>
                        <span>
                            <el-button v-if="data.children!=undefined"  size="mini" type="text" icon="el-icon-plus" circle @click.stop="newPlan(node,data)"></el-button>
                            <el-button v-else size="mini" type="text" icon="el-icon-minus" circle @click.stop="removePlan(node,data)"></el-button>
                        </span>
                    </span>
                </template>
            </el-tree>
        </el-col>
        <el-col :span="17">
            <el-form  label-position="left">
                <el-row>
                    <!--<el-col :span="4" >-->
                    <!--<el-form-item label="是否为默认方案">-->
                    <!--<el-checkbox v-model="warningData[nowClassIndexOf].children[nowPlanIndexOf].plan.isDefault"  size="large"/>-->
                    <!--</el-form-item>-->
                    <!--</el-col>-->
                    <el-col :span="7" :offset="2">
                        <el-form-item label="方案名称">
                            <el-input @change="labelChange" v-model="warningData[nowClassIndexOf].children[nowPlanIndexOf].label"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7" :offset="2">
                        <el-form-item label="数据名称">
                            <el-select @change=" dataSourceChange"  v-model="warningData[nowClassIndexOf].children[nowPlanIndexOf].plan.dataSource" placeholder="请选择">
                                <el-option
                                        v-for="item in dataSourceOptions"
                                        :key="item.DATSRC_ID"
                                        :label="item.DATSRC_NAME"
                                        :value="item.DATAURL"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7" :offset="2">
                        <el-form-item label="对比字段">
                            <el-select v-model="warningData[nowClassIndexOf].children[nowPlanIndexOf].plan.contrast" placeholder="请选择">
                                <el-option
                                        v-for="item in itemData"
                                        :key="item.id"
                                        :label="item.label"
                                        :value="item.COLUMN_NAME"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7" :offset="2">
                        <el-form-item label="对比时间">
                            <el-select @change="timeTypeChange"  v-model="warningData[nowClassIndexOf].children[nowPlanIndexOf].plan.contrastTimeType" placeholder="请选择">
                                <el-option
                                        v-for="item in contrastTimeOptions"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item>
                            <el-input v-if="warningData[nowClassIndexOf].children[nowPlanIndexOf].plan.contrastTimeType==3" type="number" v-model="warningData[nowClassIndexOf].children[nowPlanIndexOf].plan.contrastTimeData" placeholder="请输入天数"/>
                            <el-date-picker
                                    v-else-if="warningData[nowClassIndexOf].children[nowPlanIndexOf].plan.contrastTimeType==2"
                                    v-model="warningData[nowClassIndexOf].children[nowPlanIndexOf].plan.contrastTimeData"
                                    placeholder="请选择日期"
                                    type="data"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-divider />
                        <el-form-item label="预警单位">
                            <el-scrollbar height="150px" always>
                                <el-tree
                                        class="filter-tree"
                                        :data="organizationList"
                                        :props="defaultProps"
                                        :default-checked-keys="warningData[nowClassIndexOf].children[nowPlanIndexOf].plan.organizationChecked"
                                        :default-expanded-keys="warningData[nowClassIndexOf].children[nowPlanIndexOf].plan.organizationChecked"
                                        show-checkbox
                                        node-key="BLOCK_ID"
                                        ref="tree"
                                        @check-change="checked"
                                >
                                    <!--:default-checked-keys="warningData[nowClassIndexOf].children[nowPlanIndexOf].plan.organizationChecked"-->
                                    <template #default="{ node }">
                                    <span class="custom-tree-node">
                                        <i class="el-icon-s-home"></i>
                                        <span>{{ node.label }}</span>
                                    </span>
                                    </template>
                                </el-tree>
                            </el-scrollbar>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-divider />
                        <el-col :span="5" :offset="19">
                            <el-button size="mini" @click.stop="addItem">添加</el-button>
                            <el-button size="mini" :disabled="warningData[nowClassIndexOf].children[nowPlanIndexOf].plan.item.length<=1" @click.stop="removeItem">删除</el-button>
                        </el-col>
                    </el-col>
                    <el-col :span="24">
                        <el-table
                                :data="warningData[nowClassIndexOf].children[nowPlanIndexOf].plan.item"
                                style="width: 100%"
                                stripe
                                height="300"
                                fit
                        >
                            <!--<el-table-column prop="index" label="序号" align="center"/>-->
                            <el-table-column prop="logic" label="逻辑" align="center">

                                <template #default="scope">
                                    <el-select
                                            v-model="scope.row[scope.column.property]"
                                            placeholder="请选择"
                                            :disabled="scope.$index==0"
                                    >
                                        <el-option
                                                v-for="item in refreshLogic"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value"
                                        >
                                        </el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column prop="left" label="左值" align="center">
                                <template #default="scope">
                                    <!--<span>{{ scope.row[scope.column.property]}}</span>-->
                                    <el-input type="number" v-model="scope.row[scope.column.property]" placeholder="请输入天数"/>
                                </template>
                            </el-table-column>
                            <el-table-column prop="leftOperator" label="左运算符" >
                                <template #default="scope">
                                    <el-select v-model="scope.row[scope.column.property]" placeholder="请选择">
                                        <el-option
                                                v-for="item in operatorList"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value"
                                        >
                                        </el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column prop="data" label="数据" align="center">
                                <template #default="scope">
                                    <el-select v-model="scope.row[scope.column.property]" placeholder="请选择">
                                        <el-option
                                                v-for="item in itemData"
                                                :key="item.id"
                                                :label="item.label"
                                                :value="item.COLUMN_NAME"
                                        >
                                        </el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column prop="rightOperator" label="右运算符" align="center">
                                <template #default="scope">
                                    <el-select v-model="scope.row[scope.column.property]" placeholder="请选择">
                                        <el-option
                                                v-for="item in operatorList"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value"
                                        >
                                        </el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column prop="right" label="右值" align="center">
                                <template #default="scope">
                                    <el-input type="number" v-model="scope.row[scope.column.property]"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="mode" label="方式" align="center">
                                <template #default="scope">
                                    <el-select v-model="scope.row[scope.column.property]" placeholder="请选择">
                                        <el-option
                                                v-for="item in modeList"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value"
                                        >
                                        </el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-col>
                </el-row>
            </el-form>
        </el-col>
        <el-col :span="24">
            <el-col :span="5" :offset="19">
                <el-button size="mini" @click.stop="beUsed(0)">停用</el-button>
                <el-button size="mini" type="primary" @click.stop="beUsed(1)">应用</el-button>
                <el-button size="mini" type="primary" @click.stop="submit">保存</el-button>
                <!--<el-button size="mini" type="primary" @click.stop="getWarringList">获取</el-button>-->
            </el-col>
        </el-col>
    </el-row>
</template>

<script>
  import axios from 'axios';
  import { ElMessage } from 'element-plus'
  export default {
    name: "warning-setting",
    data(){
      return{
        classIndex:1,//组别唯一标识
        planIndex:1,//方案唯一标识
        itemIndex:1,//条件唯一标识
        nowClassIndexOf:0,//当前点击的组别下标
        nowPlanIndexOf:0,//当前点击的方案下标
        warningData:[{
          label:"组别1",
          index:0,
          children:[{
            label:"方案1",
            index:0,
            parentLabel:"组别1",
            parentIndex:0,
            plan:{
              dataSource:"",
              isDefault:false,//是否默认方案
              contrastTimeType:1,//对比时间下拉
              contrastTimeData:"",//对比时间
              organizationChecked:[],//选中的预警单位
              contrast:"",
              item:[{
                index:0,
                logic:"AND",//逻辑
                left:0,//条件左值
                leftOperator:"<",//左运算符
                data:"",//数据
                rightOperator:"<",//右运算符
                right:"1",//右值
                mode:"差值"//方式
              }]
            }
          }]
        }],
        defaultProps: {
          children: 'children',
          label: 'label',
        },
        plan:{
          isDefault:false,
          contrastTimeType:1,
          contrastTimeData:"",
          item:[{
            left:0,
            leftOperator:"<",
            data:"",
            rightOperator:"<",
            right:"1",
            mode:"差值"
          }]
        },
        organizationList:{},//预警单位列表
        dataSourceOptions:[],//数据源列表
        itemData:[],//条件数据列表
        contrastTimeOptions:[{
          value:1,
          label:"前一天",
        },{
          value:2,
          label:"指定年月"
        },{
          value:3,
          label:"前N天平均值"
        }],
        operatorList:[{
          value:"<",
          label:"<",
        },{
          value:"<=",
          label:"<=",
        },{
          value:"=",
          label:"=",
        },{
          value:"无",
          label:"无"
        }],
        modeList:[{
          value:"差值",
          label:"差值",
        },{
          value:"百分比",
          label:"百分比",
        }],
        refreshLogic:[{
          value: "AND",
          label: "与"
        },{
          value: "OR",
          label: "或"
        }]
      }
    },
    mounted(){
      this.getOrganizationList();
      this.getDataSource();
    },
    methods:{
      //获取数据源
      getDataSource(){
        axios.get(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/datasource")
          .then(res =>{
            //this.dataSourceOptions = res.data.datas;
            for(let i in res.data.datas){
              if(res.data.datas[i].HEAD.length!=0){
                this.dataSourceOptions.push(res.data.datas[i])

              }
            }
            //console.log("数据源",this.dataSourceOptions)
            this.getWarringList();
          })
      },
      //获取预警单位列表
      getOrganizationList(){
        let url = process.env.VUE_APP_SERVER + "/dataprovider/systemdata/blockData";
        // let token = 'eyJhbGciOiJSUzI1NiJ9.eyJsb2dpbl9uYW1lIjoiMDA2OTk4OTMiLCJ1c2VyX2lkIjoiMWNwM2RsYWQ4cm9hNTRsc29jeWl0MTI2Iiwib3JnYW5pemF0aW9uIjoiT1JHQVRMMTEwMDA1ODgyIiwiaXNzIjoiYTM2YzMwNDliMzYyNDlhM2M5Zjg4OTFjYjEyNzI0M2MiLCJkaXNwbGF5X25hbWUiOiLmnY7lrrbph5EiLCJyZWdpb24iOiJUTCIsImlhdCI6MTY1MzQ3MjA3MCwiZXhwIjoxNjU2MDY0MDcwfQ.Wly0YfUnzHZEMbnzaOqXiDtOqieOKdSRQAkj6z6WHUrby4-7vCcLLf3SJhiOZkYIDI234OvNV9KPqFQm4rcHkubPOZwU2FHbSLUdPMCAe5cneDDCkhL_lWH8SDGV0prZh1jwcgoa5_jCyqVc0tJpen17M8bPIY3biLVavwUPUffYLjzWSqj-qgI8C395dJ6y2mwKtN7mSGxqlnZjW_LH-07M-1f6hcg6fJaKRE-Vdr6L4ngQ5Es_j4_7ExywP71nQbQxuKYPRpujv5RtK5vAXG4RT6uMmytjwVNc2DmRshSWFKaGow2DROpeVJlbQIN6tM_KRuRYwURsfH6ygbtjkA'
        let token = localStorage.getItem("lyqtJwt");
        axios.get(url,{
          headers:{"authorization": "Bearer " + token},
        }).then(res=>{
            this.organizationList=res.data;
        })
      },
      //获取方案
      getWarringList(){
        // let token = "eyJhbGciOiJSUzI1NiJ9.eyJsb2dpbl9uYW1lIjoiMDA2OTk4OTMiLCJ1c2VyX2lkIjoiMWNwM2RsYWQ4cm9hNTRsc29jeWl0MTI2Iiwib3JnYW5pemF0aW9uIjoiT1JHQVRMMTEwMDA1ODgyIiwiaXNzIjoiYTM2YzMwNDliMzYyNDlhM2M5Zjg4OTFjYjEyNzI0M2MiLCJkaXNwbGF5X25hbWUiOiLmnY7lrrbph5EiLCJyZWdpb24iOiJUTCIsImlhdCI6MTY1MzQ3MjA3MCwiZXhwIjoxNjU2MDY0MDcwfQ.Wly0YfUnzHZEMbnzaOqXiDtOqieOKdSRQAkj6z6WHUrby4-7vCcLLf3SJhiOZkYIDI234OvNV9KPqFQm4rcHkubPOZwU2FHbSLUdPMCAe5cneDDCkhL_lWH8SDGV0prZh1jwcgoa5_jCyqVc0tJpen17M8bPIY3biLVavwUPUffYLjzWSqj-qgI8C395dJ6y2mwKtN7mSGxqlnZjW_LH-07M-1f6hcg6fJaKRE-Vdr6L4ngQ5Es_j4_7ExywP71nQbQxuKYPRpujv5RtK5vAXG4RT6uMmytjwVNc2DmRshSWFKaGow2DROpeVJlbQIN6tM_KRuRYwURsfH6ygbtjkA";
        let token = localStorage.getItem("lyqtJwt");
        let url = process.env.VUE_APP_SERVER + "/dataprovider/businessdata/warning/search";
        axios.get(url,{
          headers:{"authorization": "Bearer " + token},
        }).then(res=>{
          if(res.data.data.length==0){
            return
          }
          res.data.data.forEach(item=>{
            let plans = JSON.parse(item.programData);
            plans.forEach(e=>{
              if(e.classIndex>this.classIndex){
                this.classIndex = e.classIndex;
              }
              if(e.itemIndex>this.itemIndex){
                this.itemIndex = e.itemIndex;
              }
              if(e.planIndex>this.planIndex){
                this.planIndex = e.planIndex;
              }
            })
          });
          let arr = [];
          for(let i = 0;i<this.classIndex;i++){
            let n =i;
            n++;
            arr.push({
              label:"组别"+n,
              index:i,
              children:[]
            })
          }

          res.data.data.forEach(item=>{
            let plans = JSON.parse(item.programData);
            //console.log(plans)
            plans.forEach(Item=>{
              //e.parentIndex
              let code = (arr || []).findIndex((arr) => arr.index == Item.parentIndex);
              console.log(code)
              console.log(item)
              Item.programId = item.programId;
              console.log(arr)
              arr[code].children.push(Item);
            })
          });
          console.log("arr",arr)
          console.log(this.warningData[0])
          console.log(this.warningData[this.nowClassIndexOf].children[this.nowPlanIndexOf])
          this.warningData = arr;
          this.nowClassIndexOf = 0;
          this.nowPlanIndexOf = 0;
          this.dataSourceOptions.forEach(item=>{
            if(item.DATAURL == this.warningData[this.nowClassIndexOf].children[this.nowPlanIndexOf].plan.dataSource){
              this.itemData = item.HEAD
            }
          })
        })
      },

      submit(){
        let data = this.warningData[this.nowClassIndexOf].children[this.nowPlanIndexOf];
        data.plan.item.forEach(item=>{
          for(let i in this.itemData){
            if(this.itemData[i].COLUMN_NAME==item.data){
              item.label = this.itemData[i].label
            }
          }
        })
        data.classIndex= this.classIndex;
        data.planIndex= this.planIndex;
        data.itemIndex= this.itemIndex;
        data.parentLabel = this.warningData[this.nowClassIndexOf].children[this.nowPlanIndexOf].label
        data.parentIndex = this.nowClassIndexOf;
        // let token = "eyJhbGciOiJSUzI1NiJ9.eyJsb2dpbl9uYW1lIjoiMDA2OTk4OTMiLCJ1c2VyX2lkIjoiMWNwM2RsYWQ4cm9hNTRsc29jeWl0MTI2Iiwib3JnYW5pemF0aW9uIjoiT1JHQVRMMTEwMDA1ODgyIiwiaXNzIjoiYTM2YzMwNDliMzYyNDlhM2M5Zjg4OTFjYjEyNzI0M2MiLCJkaXNwbGF5X25hbWUiOiLmnY7lrrbph5EiLCJyZWdpb24iOiJUTCIsImlhdCI6MTY1MzQ3MjA3MCwiZXhwIjoxNjU2MDY0MDcwfQ.Wly0YfUnzHZEMbnzaOqXiDtOqieOKdSRQAkj6z6WHUrby4-7vCcLLf3SJhiOZkYIDI234OvNV9KPqFQm4rcHkubPOZwU2FHbSLUdPMCAe5cneDDCkhL_lWH8SDGV0prZh1jwcgoa5_jCyqVc0tJpen17M8bPIY3biLVavwUPUffYLjzWSqj-qgI8C395dJ6y2mwKtN7mSGxqlnZjW_LH-07M-1f6hcg6fJaKRE-Vdr6L4ngQ5Es_j4_7ExywP71nQbQxuKYPRpujv5RtK5vAXG4RT6uMmytjwVNc2DmRshSWFKaGow2DROpeVJlbQIN6tM_KRuRYwURsfH6ygbtjkA";
        let token = localStorage.getItem("lyqtJwt");
        let url = process.env.VUE_APP_SERVER + "/dataprovider/businessdata/warning/add?programName=";
        url += this.warningData[this.nowClassIndexOf].children[this.nowPlanIndexOf].label;
        url +=`&type=系统&isDefault=`;
        console.log(url)
        if(data.plan.isDefault==true){
          url += 1
        }else{
          url += 0
        }
        url+=`&parentIndex=${this.classIndex-1}`
        console.log("---------------",data)
        axios.post(url,data,{
          headers:{"authorization": "Bearer " + token},
        }).then(res=>{
          console.log(res.data.msg)
          this.$store.state.warningList = [];
          ElMessage.success(res.data.msg)
        })
      },
      beUsed(type){
        // let token = "eyJhbGciOiJSUzI1NiJ9.eyJsb2dpbl9uYW1lIjoiMDA2OTk4OTMiLCJ1c2VyX2lkIjoiMWNwM2RsYWQ4cm9hNTRsc29jeWl0MTI2Iiwib3JnYW5pemF0aW9uIjoiT1JHQVRMMTEwMDA1ODgyIiwiaXNzIjoiYTM2YzMwNDliMzYyNDlhM2M5Zjg4OTFjYjEyNzI0M2MiLCJkaXNwbGF5X25hbWUiOiLmnY7lrrbph5EiLCJyZWdpb24iOiJUTCIsImlhdCI6MTY1MzQ3MjA3MCwiZXhwIjoxNjU2MDY0MDcwfQ.Wly0YfUnzHZEMbnzaOqXiDtOqieOKdSRQAkj6z6WHUrby4-7vCcLLf3SJhiOZkYIDI234OvNV9KPqFQm4rcHkubPOZwU2FHbSLUdPMCAe5cneDDCkhL_lWH8SDGV0prZh1jwcgoa5_jCyqVc0tJpen17M8bPIY3biLVavwUPUffYLjzWSqj-qgI8C395dJ6y2mwKtN7mSGxqlnZjW_LH-07M-1f6hcg6fJaKRE-Vdr6L4ngQ5Es_j4_7ExywP71nQbQxuKYPRpujv5RtK5vAXG4RT6uMmytjwVNc2DmRshSWFKaGow2DROpeVJlbQIN6tM_KRuRYwURsfH6ygbtjkA";
        let token = localStorage.getItem("lyqtJwt");
        //let searchUrl = process.env.VUE_APP_SERVER + "/dataprovider/businessdata/warning/search?AppID=54e8099c-4202-485f-9503-13bd0dce5f53&AppSercect=4mjp5emfes3g6xxuxd4nulux";
        let useUrl = process.env.VUE_APP_SERVER + `/dataprovider/businessdata/warning/use?programId=${this.warningData[this.nowClassIndexOf].children[this.nowPlanIndexOf].programId}&isDefault=${type}`;
        axios.get(useUrl,{
          headers:{"authorization": "Bearer " + token}
        }).then(res=>{
          console.log(res)
          ElMessage(res.data.msg)
        })
      },
      dataSourceChange(val){
        for(let i in this.dataSourceOptions){
          if(this.dataSourceOptions[i].DATAURL==val){
            //console.log(this.dataSourceOptions[i])
            this.itemData = this.dataSourceOptions[i].HEAD
          }
        }
        this.warningData[this.nowClassIndexOf].children[this.nowPlanIndexOf].plan.item.forEach(item=>{
          item.data = ""
        })
      },
      labelChange(val){
        if(val == ""){
          this.warningData[this.nowClassIndexOf].children[this.nowPlanIndexOf].label="方案"
        }
      },
      //预警单位预警单位勾选刷新
      checked(){
        let arr = [];
        this.$refs.tree.getCheckedNodes().forEach(item=>{
          arr.push(item.BLOCK_ID)
        })
        this.warningData[this.nowClassIndexOf].children[this.nowPlanIndexOf].plan.organizationChecked=arr;
      },
      //组别树节点点击
      classClick(node,data){
        if(node.children==undefined){
          //console.log(node,data,$event)
          let nowClassIndexOf = 0;
          let nowPlanIndexOf = 0;
          for(let i in this.warningData){
            if(this.warningData[i].index==data.parent.data.index){
              //console.log(this.warningData[i])
              nowClassIndexOf = i;
              //console.log("nowClassIndexOf",nowClassIndexOf)
            }
          }
          for(let i in this.warningData[nowClassIndexOf].children){
            if(this.warningData[nowClassIndexOf].children[i].index==node.index){
              //console.log(this.warningData[nowClassIndexOf].children[i])
              nowPlanIndexOf = i ;
              //console.log("nowPlanIndexOf",nowPlanIndexOf)
            }
          }
          this.nowClassIndexOf = nowClassIndexOf;
          this.nowPlanIndexOf = nowPlanIndexOf;
          this.$refs.tree.setCheckedKeys(this.warningData[this.nowClassIndexOf].children[this.nowPlanIndexOf].plan.organizationChecked,false)
        }
      },
      //对比时间切换
      timeTypeChange(){
        this.warningData[this.nowClassIndexOf].children[this.nowPlanIndexOf].plan.contrastTimeData = ""
      },
      //添加组别
      newClass(){
        let num = this.classIndex;
        num+=1;
        let num1 = this.planIndex;
        num1+=1;
        let num2 = this.itemIndex;
        num2+=1;
        this.warningData.push({
          label:"组别"+num,
          index:this.classIndex,
          children:[{
            label:"方案"+num1,
            parentLabel:"组别"+num,
            parentIndex:this.classIndex,
            index:this.planIndex,
            plan:{
              isDefault:false,
              dataSource:"",
              contrastTimeType:1,
              contrastTimeData:"",
              organizationChecked:[],
              item:[{
                logic:"AND",
                label:"条件"+num2,
                index:this.itemIndex,
                left:0,
                leftOperator:"<",
                data:"",
                rightOperator:"<",
                right:"1",
                mode:"差值"
              }]
            }
          }]
        })

        this.classIndex++;
        this.planIndex++;
        this.itemIndex++;
        // console.log(this.warningData)
        // console.log(this.organizationList)
      },
      //添加方案
      newPlan(node,data){
        console.log(node,data)
        //console.log(this.warningData.findIndex(data));
        let num1 = this.planIndex;
        num1+=1;
        let num2 = this.itemIndex;
        num2+=1;
        for(let i in this.warningData){
          if(this.warningData[i].index==data.index){
            console.log(this.warningData[i].children)
            this.warningData[i].children.push({
              label:"方案"+num1,
              index:this.planIndex,
              plan:{
                isDefault:false,
                dataSource:"",
                contrastTimeType:1,
                contrastTimeData:"",
                organizationChecked:[],
                item:[{
                  logic:"AND",
                  label:"条件"+num2,
                  index:this.itemIndex,
                  left:0,
                  leftOperator:"<",
                  data:"",
                  rightOperator:"<",
                  right:"1",
                  mode:"差值"
                }]
              }
            })
          }
        }
        this.planIndex++;
        this.itemIndex++;
      },
      //添加条件
      addItem(){
        this.warningData[this.nowClassIndexOf].children[this.nowPlanIndexOf].plan.item.push({
          index:this.itemIndex,
          logic:"AND",
          left:0,
          leftOperator:"<",
          data:"",
          rightOperator:"<",
          right:"1",
          mode:"差值"
        })
        this.itemIndex++;
      },
      //删除组别
      removeClass(){
        if(this.warningData.length<=1){
          return
        }
        this.warningData.pop()
      },
      //删除条件
      removeItem(){
        if(this.warningData[this.nowClassIndexOf].children[this.nowPlanIndexOf].plan.item.length==1){
          return
        }
        this.warningData[this.nowClassIndexOf].children[this.nowPlanIndexOf].plan.item.pop()
      },
      //删除方案
      removePlan(node,data){
        const parent = node.parent
        const children = parent.data.children || parent.data
        const index = children.findIndex((d) => d.index === data.index)
        children.splice(index, 1)
        // dataSource.value = [...dataSource.value]
      },
    }
  }
</script>
<style scoped>
    .warningTree{
        position: relative;
        overflow: auto;
        width: 50%;
        height: 600px;
        border: 1px solid #ddd;
        line-height: normal;
        z-index: 204;
    }
    .page-tree {
        position: relative;
        overflow: auto;
        width: 90%;
        height: 680px;
        border: 1px solid #ddd;
        line-height: normal;
        z-index: 204;
    }
    /deep/input::-webkit-outer-spin-button,
    /deep/input::-webkit-inner-spin-button {
        -webkit-appearance: none;
    }
    /deep/input[type="number"]{
        -moz-appearance: textfield;
    }
</style>